/* eslint-disable no-unused-expressions */
/* eslint-disable no-mixed-operators */

import React, { useEffect, useRef } from 'react';
import BenefitAnimation from './BenefitsCarousel.js';
import JumpLink from './JumpLink.js';

import { initializeYouTubePlayer } from '../scripts/bgvideo';

const Header = () => {
    const buttonRef = useRef(null);

    useEffect(() => {
        initializeYouTubePlayer(() => {
            const button = buttonRef.current;
            if (button) {
                const handleButtonClick = (event) => {
                    if (event.type === 'click' || event.key === 'Enter') {
                        if (!button.classList.contains('yt-paused')) {
                            window.ytPlayer.pauseVideo();
                            button.classList.add('yt-paused');
                        } else {
                            window.ytPlayer.playVideo();
                            button.classList.remove('yt-paused');
                            button.blur();
                        }
                    }
                };

                button.addEventListener('click', handleButtonClick);
                button.addEventListener('keydown', handleButtonClick);

                return () => {
                    button.removeEventListener('click', handleButtonClick);
                    button.removeEventListener('keydown', handleButtonClick);
                };
            }
        });
    }, []);

    return (
        <header id="homepage-header">
            <div id="background-video-container" aria-label="Background video of the NYC Subway">
                <div data-video="35NuL57kkuY" className="header-video js-background-video">
                    <div className="header-background">
                        <div id="yt-player"></div>
                        <div className="js-video-overlay"></div> 
                    </div>
                </div>
                <button ref={buttonRef}></button>
            </div>

            <h1>
                More
                <BenefitAnimation /> 
            </h1>

            <JumpLink /> 
        </header>
        
    );
};

export default Header;